import { render, staticRenderFns } from "./LanguageSelectorModal.vue?vue&type=template&id=568ec0b4"
import script from "./LanguageSelectorModal.vue?vue&type=script&lang=js"
export * from "./LanguageSelectorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports